import { styled } from '@mui/material/styles';
import { Link } from 'core/common/ui/ui-kit';

export const BoldStyled = styled('b')``;

export const BreakStyled = styled('br')``;

export const ListItemStyled = styled('li')`
  display: block;
  margin-top: 10px;
  color: ${({ theme }) => theme.palette.text.main};

  &::before {
    font-weight: bold;
    content: counters(item, '.') '. ';
    counter-increment: item;
  }
`;

export const LinkStyled = styled(Link)`
  text-decoration: underline;
  color: ${({ theme }) => theme.palette.text.main};
`;

export const NumberListStyled = styled('ol')`
  counter-reset: item;
`;
